module.exports = __webpack_public_path__ + "img/nato.96a364e4.svg";